import * as React from "react";
const SvgIconMinus = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 2", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1H13", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }));
export default SvgIconMinus;
